<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Button from 'primevue/button'
import { usarSesion } from '@/stores/guion'
import { token } from '@/api/cliente'

const sesion = usarSesion()
const router = useRouter()
const oscuro = ref(localStorage.getItem('botia.oscuro') === '1')

function alternarTema() {
  oscuro.value = !oscuro.value
  document.documentElement.classList.toggle('oscuro', oscuro.value)
  localStorage.setItem('botia.oscuro', oscuro.value ? '1' : '0')
}

function salir() {
  token.olvidar()
  sesion.salir()
  router.push('/entrar')
}

onMounted(() => {
  document.documentElement.classList.toggle('oscuro', oscuro.value)
})
</script>

<template>
  <div class="app">
    <header v-if="sesion.autenticado" class="barra">
      <span class="marca">Guiones del bot</span>
      <Button label="Tenants" text size="small" icon="pi pi-list" @click="router.push('/')" />
      <span class="espacio" />
      <span class="tenue pequeno">{{ sesion.usuario?.nombre || sesion.usuario?.username }}</span>
      <Button :icon="oscuro ? 'pi pi-sun' : 'pi pi-moon'" text rounded size="small"
              v-tooltip.bottom="'Cambiar tema'" @click="alternarTema" />
      <Button icon="pi pi-sign-out" text rounded size="small"
              v-tooltip.bottom="'Salir'" @click="salir" />
    </header>

    <main class="contenido">
      <RouterView />
    </main>

    <Toast position="bottom-right" />
    <ConfirmDialog />
  </div>
</template>
